<template>
<div>
    <div class="container" v-show="quiz">
      <div class="heading-content-title">{{ $t('lesson.question.title') }}</div>

      <div class="quiz-box font-jp" v-for="(question,index) in questionList" :key="index" v-show="quiz">

          <!-- Question -->
          <div class="questions-combined">
            <div class="box-question-explanation" @click="changeTrans(selectedLanguage.key)">
              <p v-show="!trans_instruction" v-html="question.instruction"></p>
              <p v-show="trans_instruction" v-html="question[selectedLanguage.key + '_instruction']"></p>
            </div>
    
            <div class="box-question">
              <p v-html="question.question"></p>
            </div>
          </div>
          
          <div class="slide">
            <transition name="slide-fade" mode="in-out">
              <div class="slide-image square" :style="{backgroundImage: 'url(' + question.image + ')'}"></div>
            </transition>
          </div>

          <!-- Answer Choices -->
          <div class="box-propositions">
            <ul>
              <li v-for="(proposition,index) in question.propositions" :key="index" class="button button-choice" @click="selectResponse(proposition,index)" :class=" answered ? check(proposition, index) : ''" v-html="proposition.props">
                <div class="far fa-circle" v-if="correct_answerd && (answered ?  proposition.correct: '')"></div>
                <div class="fas fa-times" v-if="( incorrect_answerd == index) && (answered ?  !proposition.correct: '')"></div>
              </li>
            </ul>
          </div>

      </div>

      <!-- Footer -->
      <div class="footer-quiz">
        <div class="box-button button-next-done" v-if="quiz" > 
            <button class="button next"  :class="(answered) ? 'button-primary' : 'disabled'" @click="nextQuestion()">{{ $t('common.button.next') }}</button>
            <br>
        </div>
      </div>
  
    </div>
    <!-- /container -->

    <div class="container score" v-if="!quiz">
      <div class="heading-content-title">{{ $t('lesson.question.title') }}</div>
      <div class="box-score">
        <div class="image-score" :class="score_result"></div>
        <div class="score-result" :class="score_result">{{ $t('lesson.question.score.title') }} <p class="score-shown"><span class="score-count">{{score}}</span>/{{questions.length}}</p></div>
        
        <p class="message">
        <template v-if="score_result == 'perfect'">
          {{ $t('lesson.question.score.perfect.message_1') }}<br>
          {{ $t('lesson.question.score.perfect.message_2') }}
        </template>
        <template v-else-if="score_result == 'pass'">
          {{ $t('lesson.question.score.pass.message_1') }}
        </template>
        <template v-else-if="score_result == 'failure'">
          {{ $t('lesson.question.score.failure.message_1') }}
        </template>
        
        </p>
      </div>
    </div>

</div>
</template>

<script>

import {appEnv, useCoachmark} from './../../config';

import questionLog from '../../mixins/question-log';
import {mapGetters} from 'vuex';

import LessonMultiAudio from './LessonMultiAudio.vue'

import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';

export default {
  mixins: [
    questionLog
  ],
  name: "LessonQuestion",
  components: {
    'lessonmultiaudio': LessonMultiAudio,
  },
  props: {
    step: {
      type: String,
      required: true
    },
    quizData: {
      type: Object,
      required: true
    },
    questions: {
      type: Array,
      required: true
    },
    audios: {
      type: Array
    },
  },
  data(){
    return{
      stepSub: 'quiz',
      audioType: 'audio',
      lessonId: null,
      contentOrder: null,

      a:0,
      b:1,
      next:true,
      quiz:true,
      score:0,
      progress:0,
      answered:false,
      // next_step:false,
      correct_answerd:false,
      incorrect_answerd:null,
      score_result:null,

      colorCodes: {
        info: {
          color: "green"
        },
        warning: {
          color: "orange",
          threshold: 15
        },
        alert: {
          color: "red",
          threshold: 10
        }
      },

      trans_instruction:false,
      authUser: null,
      driver: null,
      storage: {}
    }
  },
  computed: {
    ...mapGetters([
      'selectedLanguage'
    ]),
    isListening() {
      if (this.step == 'listening_practice') {
        return true;
      }
      return false;
    },
    questionList () {
      const questionSlise = this.questions.slice(this.a,this.b)
      
      return _.map(questionSlise, (value, index) => {
        let newQuestion = _.cloneDeep(value)
        newQuestion.propositions = _.shuffle(newQuestion.propositions)
        return newQuestion
      })
    }
  },

  watch: {
    answered() {
      if (!this.isListening) {return}
      if (this.answered) {
        this.$refs.lessonmultiaudio.pauseAudio();
      }
    },
    quiz() {
      if (!this.isListening) {return}
      if (!this.quiz) {
        this.$refs.lessonmultiaudio.stopAudio();
      }
    },

  },
  
  created() {
      
      this.authUser = this.$store.getters.getAuthUser;
      
      this.contentOrder = this.$route.params['content_order']
      this.lessonId = this.$route.params['lesson_id']
      
      if(this.driver) {
        this.driver.reset();
      } else {
        this.initCoachMark();
      }
  },

  mounted() {
    if(appEnv !== 'local') {
      const TypeSquareJS = window.TypeSquareJS;
      TypeSquareJS.loadFont && TypeSquareJS.loadFont();
    }
    
    if(useCoachmark) {
      this.storage = (appEnv === 'production') ? window.localStorage : window.sessionStorage
      
      const currentStep = this.step + '-' + this.stepSub
      
      const isCoachmarkDone = this.storage.getItem("coachmarkdone") ? JSON.parse(this.storage.getItem("coachmarkdone")) : null;
      if(!(isCoachmarkDone && currentStep in isCoachmarkDone && isCoachmarkDone[currentStep])) {
        this.showCoachMark();
      }
    }
  },
  beforeDestroy() {
  },
  methods: {
    changeTrans(key) {
      if(this.driver) {
        this.driver.reset();
      }
      
      if (key !== 'ja') {
        this.trans_instruction = !this.trans_instruction
      }
    },

    selectResponse(e, index) {
      if(this.driver && this.driver.hasHighlightedElement()) {
        return false
      }
      
      if (this.answered) {
        return;
      }

      if (e.correct) {
        this.score++;
        this.correct_answerd = true;
        this.$store.dispatch('playSoundEffect', 'correct')
      } else {
        this.incorrect_answerd = index;
        this.$store.dispatch('playSoundEffect', 'incorrect')
      }
      this.answered = true;
    },

    check(status, index) {
      if (status.correct && this.correct_answerd) {
        return 'correct'
      } else if (this.incorrect_answerd == index) {
        return 'incorrect'
      } 
    },

    nextQuestion() {
      if(this.driver && this.driver.hasHighlightedElement()) {
        return false
      }
      
      if (!this.answered) {
        return;
      }

      // exam log
      let question_id = this.$store.getters.lesson_content[this.step].content[this.contentOrder].questions[this.a].question_id;
      let answeredLog = (this.correct_answerd) ? true : false;
      let selectedLog = (this.incorrect_answerd == null) ? this.incorrect_answerd : this.incorrect_answerd + 1;
      this.questionTempLog('log', question_id, answeredLog, selectedLog);
      
      if (this.questions.length - 1 == this.a) {
        this.quiz = false;
        // this.next_step = true;
        if (this.score == this.questions.length) {
          this.score_result = 'perfect';
        } else if (this.score <= 2) {
          this.score_result = 'failure';
        } else {
          this.score_result = 'pass';
        }
        this.lessonTempLog(this.score_result);
        
        this.$emit('scoreresult', this.score_result)

        this.$emit('finquiz')
        this.$emit('passedquiz')
        

        // Update Log
        this.questionLog()

      } else {
        this.progress = this.progress + (100/this.questions.length);
        this.a++;
        this.b++;
        this.answered = false;
        this.correct_answerd = false;
        this.incorrect_answerd = null;
      }
    },

    completedLesson() {
    },
    initCoachMark() {
      if(this.driver) {
        this.driver.reset()
      } else {
        const driverOverlay = document.getElementById('driver-page-overlay')
        const driverStage = document.getElementById('driver-highlighted-element-stage')
        const driverItem = document.getElementById('driver-popover-item')
        const driverItem2 = document.getElementById('driver-popover-item2')
        
        if(driverOverlay) {
          driverOverlay.remove()
        }
        if(driverStage) {
          driverStage.remove()
        }
        if(driverItem) {
          driverItem.remove()
        }
      }
    },
    showCoachMark() {
      let self = this;
      
      if(this.authUser.language == 'ja') return false;

       this.driver = new Driver({
          className: "scoped-class-dark",
          animate: true,
          opacity: 0.7,
          padding: 10,
          allowClose: true,
          overlayClickNext: false,
          DoneBtnText: "Done",
          CloseBtnText: "Close",
          NextBtnText: "Next",
          PrevBtnText: "Previous step",
          onReset: (e) => {
          
            let coachMarks = JSON.parse(this.storage.getItem("coachmarkdone")|| null);
            if(!coachMarks) {
              coachMarks = {};
              coachMarks[this.step + '-' + this.stepSub] = true;
            } else {
              coachMarks[this.step + '-' + this.stepSub] = true;
            }

            this.storage.setItem("coachmarkdone", JSON.stringify(coachMarks));
          }
      })
      setTimeout(() => {
        this.driver.highlight({
          element: ".box-question-explanation",
          popover: {
            className: 'popover-class',
            title: "Tap the question to see the translation",
            position:  "bottom",
            offset: 0
          }
        })
      }, 300)
    }
  }
}
</script>

<style scoped lang="scss">
  .base-timer {
    position: relative;
    width: 75px;
    height: 75px;
    margin: 10px auto; // new
    &__circle {
      fill: none;
      stroke: none;
    }
    &__path-elapsed {
      stroke-width: 7px;
      stroke:grey;
      stroke: #e0e0e0;
    }
    &__label {
      position: absolute;      
      width: 75px;
      height: 75px;
      top: 0; 
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
    }
    &__path-remaining {
      stroke-width: 7px;
      stroke-linecap: round;
      transform: rotate(90deg);
      transform-origin: center;
      transition: 1s linear all;
      stroke: rgb(65, 184, 131); // green
    }
    &__svg {
      transform: scaleX(-1);
    }
    &__path-remaining {
      stroke-width: 7px;
      stroke-linecap: round;
      transform: rotate(90deg);
      transform-origin: center;
      transition: 1s linear all;
      fill-rule: nonzero;
      stroke: currentColor;
      &.green {
        color: rgb(65, 184, 131);
      }
      &.orange {
        color: orange;
      }
      &.red {
        color: red;
      }
    }
  }

  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: opacity .3s;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    opacity: 0;
  }
  
</style>